export * from './vprInfo.component';
